import { normalizeLocale } from './helpers/normalizeLocale';
export var format = function (locale) {
    function transform(value) {
        return {
            pipe: function () {
                var fns = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    fns[_i] = arguments[_i];
                }
                return fns.reduce(function (v, f) { return f(v, normalizeLocale(locale), value); }, value);
            },
        };
    }
    return transform;
};
//# sourceMappingURL=format.js.map